import axios from 'axios';
import i18n from '../i18n';
import {inAnteprima} from '../skin';
import i18next from 'i18next';

/**
 * Le chiamate del casino' (moduli Casino' e Live casino).
 *
 * I giochi arrivano dal FORNITORE attraverso casino-service, dietro il
 * gateway. Il sito non sa niente del fornitore: chiede l'elenco e, per
 * giocare, un indirizzo da aprire nella pagina del gioco. Puntate e vincite
 * le scrive il fornitore sul conto del giocatore (cassa «casino» del
 * credit-service): qui non passa denaro.
 *
 * LE ROTTE (contratto con casino-service, da costruire):
 *
 *   GET  /public/casino/giochi?sezione=casino|liveCasino|virtualiCasino|crashGame
 *        -> [{id, nome, fornitore, categorie: [..], copertina, nuovo, prova}]
 *        pubblica: la lobby si guarda anche da scollegati
 *   GET  /public/casino/giochi/{id}
 *        -> un gioco, stessa forma; 404 GIOCO_NON_TROVATO
 *   POST /public/casino/giochi/{id}/prova  {lingua, ritorno}
 *        -> {indirizzo}  la prova gratuita, anche da scollegati;
 *        409 PROVA_NON_DISPONIBILE
 *   POST /private/casino/giochi/{id}/avvio  {prova, lingua, ritorno}
 *        -> {indirizzo}  la pagina del fornitore da aprire nella cornice,
 *        col saldo vero (serve il gettone: il gateway non la apre senza)
 *
 * Due rotte per l'avvio, non una: il gateway decide chi passa guardando
 * l'indirizzo, e una rotta sola «aperta se prova» non si puo' scrivere nella
 * sua free-list. Chi e' entrato prova dalla rotta privata con prova=true.
 *
 * Non ripiega su niente: se casino-service non risponde, la pagina lo dice
 * con codice e dettaglio, invece di mostrare giochi inventati.
 */

function base() {
  const env = typeof window !== 'undefined' && window.env ? window.env : {};
  return env.REACT_APP_API_URL || '';
}

function intestazioni() {
  const h = {'X-Client-Surface': 'FRONTEND'};
  const token = window.localStorage.getItem('access_token');
  if (token) h.Authorization = `Bearer ${token}`;
  const tenant = window.env && window.env.REACT_APP_API_TENANT;
  if (tenant) h.TENANT_ID = tenant;
  return h;
}

/** Un gioco come lo usa il sito: i campi che mancano diventano vuoti, non inventati. */
function gioco(g) {
  return {
    id: String(g.id),
    nome: g.nome || g.name || '',
    fornitore: g.fornitore || g.provider || '',
    categorie: Array.isArray(g.categorie) ? g.categorie : [],
    copertina: g.copertina || g.image || '',
    /* Quella del fornitore, se copertina e' la nostra ridotta (/copertine/):
       Copertina.js ci torna quando la nostra non arriva. */
    originale: g.copertinaOriginale || '',
    nuovo: !!g.nuovo,
    prova: !!g.prova,
  };
}

/*
 * L'ELENCO SI SCARICA UNA VOLTA E SI TIENE.
 *
 * L'elenco del Casino' e' grande (migliaia di giochi, piu' di un mega) e lo
 * chiedevano tutti: la Home, il menu, la lobby, la pagina di una categoria,
 * la ricerca, ognuno per conto suo e a ogni cambio pagina. Era la gran parte
 * dell'attesa del sito. Adesso:
 *
 *   - una richiesta sola per sezione anche se la chiedono in cinque insieme;
 *   - l'elenco resta in memoria per tutta la visita: cambiando pagina i
 *     giochi ci sono gia', senza scheletro;
 *   - una copia resta nel browser (IndexedDB, che regge i mega: la memoria
 *     di sessione no) per mezza giornata: chi torna vede subito la Home
 *     piena, e intanto l'elenco si riscarica di nascosto per la volta dopo.
 *
 * Passati FRESCO minuti dall'ultimo scaricamento, la prima richiesta lo
 * riscarica in sottofondo e intanto risponde con quello che ha: un gioco
 * spento nel backoffice sparisce alla pagina dopo, non subito. Il gioco
 * spento che si prova ad aprire lo dice comunque casino-service (404).
 */
const FRESCO = 5 * 60 * 1000;          /* cinque minuti */
const DURATA_COPIA = 12 * 60 * 60 * 1000; /* mezza giornata */
const memoria = new Map();             /* sezione -> {elenco, quando} */
const inCorso = new Map();             /* sezione -> scaricamento in corso */
const letture = new Map();             /* sezione -> prima risposta in arrivo */

const BASE_COPIA = 'lvc-casino';
const CASSETTO = 'elenchi';
let copiaAperta = null;

function apriCopia() {
  if (copiaAperta) return copiaAperta;
  copiaAperta = new Promise((risolvi) => {
    try {
      if (typeof indexedDB === 'undefined') { risolvi(null); return; }
      const r = indexedDB.open(BASE_COPIA, 1);
      r.onupgradeneeded = () => r.result.createObjectStore(CASSETTO);
      r.onsuccess = () => risolvi(r.result);
      r.onerror = () => risolvi(null);
      r.onblocked = () => risolvi(null);
    } catch (e) { risolvi(null); }
  });
  return copiaAperta;
}

function chiaveCopia(sezione) {
  const tenant = (typeof window !== 'undefined' && window.env && window.env.REACT_APP_API_TENANT) || '';
  return base() + '|' + tenant + '|' + sezione;
}

function leggiCopia(sezione) {
  return apriCopia().then((db) => new Promise((risolvi) => {
    if (!db) { risolvi(null); return; }
    try {
      const r = db.transaction(CASSETTO, 'readonly').objectStore(CASSETTO).get(chiaveCopia(sezione));
      r.onsuccess = () => {
        const v = r.result;
        risolvi(v && Array.isArray(v.elenco) && Date.now() - v.quando < DURATA_COPIA ? v : null);
      };
      r.onerror = () => risolvi(null);
    } catch (e) { risolvi(null); }
  }));
}

function scriviCopia(sezione, voce) {
  apriCopia().then((db) => {
    if (!db) return;
    try {
      db.transaction(CASSETTO, 'readwrite').objectStore(CASSETTO).put(voce, chiaveCopia(sezione));
    } catch (e) { /* navigazione privata o spazio finito: resta la memoria */ }
  });
}

/* Il collegamento con chi serve le copertine si apre appena si sa chi e',
   non al primo riquadro: risparmia il giro di rete iniziale a ogni immagine. */
const giaCollegati = new Set();
function preparaCopertine(elenco) {
  if (typeof document === 'undefined') return;
  elenco.slice(0, 40).forEach((g) => {
    let origine = '';
    try { origine = new URL(g.copertina).origin; } catch (e) { return; }
    if (!origine || giaCollegati.has(origine)) return;
    giaCollegati.add(origine);
    const l = document.createElement('link');
    l.rel = 'preconnect';
    l.href = origine;
    document.head.appendChild(l);
  });
}

function scarica(sezione) {
  if (inCorso.has(sezione)) return inCorso.get(sezione);
  const p = axios
      .get(`${base()}/public/casino/giochi`, {params: {sezione}, headers: intestazioni(), timeout: 15000})
      .then((res) => {
        const elenco = Array.isArray(res.data) ? res.data.map(gioco) : [];
        const voce = {elenco, quando: Date.now()};
        memoria.set(sezione, voce);
        scriviCopia(sezione, voce);
        preparaCopertine(elenco);
        return elenco;
      })
      .finally(() => inCorso.delete(sezione));
  inCorso.set(sezione, p);
  return p;
}

/**
 * I giochi di una sezione gia' in memoria, subito, senza aspettare niente:
 * null se non ci sono ancora. Serve a chi vuole disegnare la pagina piena
 * al primo colpo invece di passare dallo scheletro.
 */
export function giochiPronti(sezione) {
  const v = memoria.get(sezione);
  return v ? v.elenco : null;
}

/** I giochi di una sezione ('casino', 'liveCasino', 'virtualiCasino' o 'crashGame'), nell'ordine del fornitore. */
export function giochi(sezione) {
  const v = memoria.get(sezione);
  if (v) {
    if (Date.now() - v.quando > FRESCO) scarica(sezione).catch(() => {});
    return Promise.resolve(v.elenco);
  }
  if (letture.has(sezione)) return letture.get(sezione);
  if (inCorso.has(sezione)) return inCorso.get(sezione);
  /* La copia nel browser si legge in pochi millesimi; se c'e' si risponde
     con quella e si riscarica in sottofondo. */
  const p = leggiCopia(sezione).then((copia) => {
    if (memoria.has(sezione)) return memoria.get(sezione).elenco;
    if (!copia) return scarica(sezione);
    memoria.set(sezione, {elenco: copia.elenco, quando: 0});
    preparaCopertine(copia.elenco);
    scarica(sezione).catch(() => {});
    return copia.elenco;
  });
  letture.set(sezione, p);
  const via = () => { if (letture.get(sezione) === p) letture.delete(sezione); };
  p.then(via, via);
  return p;
}

/**
 * Si comincia a scaricare l'elenco subito, all'apertura del sito, mentre
 * ancora si aspettano skin e accesso: quando la Home si disegna i giochi
 * sono gia' arrivati (o quasi).
 */
export function precarica(sezioni) {
  (sezioni || []).forEach((s) => giochi(s).catch(() => {}));
}

/**
 * Un gioco solo, per la sua pagina. Se l'elenco e' gia' in memoria si prende
 * da li': la pagina ha subito nome e copertina e il gioco si avvia senza
 * aspettare un giro di rete in piu'.
 */
export function giocoPerId(id) {
  const cercato = String(id);
  for (const v of memoria.values()) {
    const g = v.elenco.find((x) => x.id === cercato);
    if (g) return Promise.resolve(g);
  }
  return axios
      .get(`${base()}/public/casino/giochi/${encodeURIComponent(id)}`, {headers: intestazioni(), timeout: 8000})
      .then((res) => gioco(res.data || {}));
}

/**
 * L'indirizzo da aprire per giocare (o provare) quel gioco. Da scollegati la
 * prova passa dalla rotta pubblica: quella privata il gateway la chiude.
 */
export function avvia(id, prova) {
  const ritorno = typeof window !== 'undefined' ? window.location.origin : '';
  const scollegato = !window.localStorage.getItem('access_token');
  const rotta = prova && scollegato
    ? `/public/casino/giochi/${encodeURIComponent(id)}/prova`
    : `/private/casino/giochi/${encodeURIComponent(id)}/avvio`;
  return axios
      .post(`${base()}${rotta}`,
          {prova: !!prova, lingua: i18n.language || 'it', ritorno},
          {headers: intestazioni(), timeout: 10000})
      .then((res) => (res.data && res.data.indirizzo) || '');
}

/**
 * Col gioco aperto, il gioco si puo' ancora giocare? Risolve se si'; se la
 * sezione e' stata bloccata per questo conto (Comandi rapidi › Gioco) rifiuta
 * con 403 GIOCO_NON_ABILITATO, come l'avvio. PaginaGioco la chiede ogni pochi
 * secondi e al no chiude il gioco.
 */
export function ancoraAbilitato(id) {
  return axios
      .get(`${base()}/private/casino/giochi/${encodeURIComponent(id)}/abilitato`,
          {headers: intestazioni(), timeout: 8000})
      .then(() => true);
}

/** Il no di ancoraAbilitato che chiude il gioco: tutti gli altri errori si lasciano passare. */
export function eBloccato(e) {
  return !!(e && e.response && e.response.status === 403 && e.response.data
      && e.response.data.code === 'GIOCO_NON_ABILITATO');
}

/**
 * L'errore scritto come lo vuole il sito.
 *
 * A CHI GIOCA una frase che capisce, col codice fra parentesi per chi chiama
 * l'assistenza: «Errore 404 - Resource not found!» non gli diceva niente.
 * NELL'ANTEPRIMA del backoffice, a chi compone la skin, codice E dettaglio
 * del servizio, mai il numero da solo, come sempre.
 *
 * Per la pagina del gioco c'e' motivoErrore, che sceglie anche i pulsanti.
 */
export function descriviErrore(e) {
  const t = (chiave, valori) => i18n.t(chiave, valori);
  if (inAnteprima()) {
    return t('I giochi arrivano dal fornitore attraverso casino-service, che non ha risposto: {{errore}}', {errore: dettaglioTecnico(e)});
  }
  const stato = e && e.response ? e.response.status : 0;
  const codice = e && e.response && e.response.data ? e.response.data.code : '';
  let frase;
  if (e && (e.code === 'ECONNABORTED' || (!e.response && e.request))) {
    frase = t('Il casinò non risponde in questo momento. Riprova tra poco.');
  } else if (stato === 401 || stato === 403) {
    frase = t('Per giocare devi accedere al tuo conto.');
  } else if (codice === 'PROVA_NON_DISPONIBILE') {
    frase = t('La prova gratuita non è disponibile per questo gioco.');
  } else if (stato === 404) {
    frase = t('I giochi non sono disponibili in questo momento. Riprova tra poco.');
  } else if (stato >= 500) {
    frase = t('Il casinò non è disponibile in questo momento. Riprova tra poco.');
  } else {
    frase = t('Qualcosa non ha funzionato. Riprova tra poco.');
  }
  return stato ? frase + ' ' + t('(codice {{codice}})', {codice: stato}) : frase;
}

/**
 * Perche' un gioco non e' partito, per il riquadro della pagina del gioco
 * (ErroreGioco): il tipo decide titolo, frase e pulsanti.
 *   nonDisponibile  il gioco non c'e' (404)
 *   nonRisponde     rete, tempo scaduto, 5xx
 *   accesso         serve il conto (401/403 da ospite)
 *   sessione        il conto c'era ma il gettone non vale piu' (401/403)
 *   prova           la prova gratuita non c'e' (PROVA_NON_DISPONIBILE)
 *   nonAbilitato    questa sezione non e' abilitata per il suo conto (GIOCO_NON_ABILITATO)
 *   altro           tutto il resto
 * tecnico: codice e dettaglio, che il riquadro mostra solo in anteprima.
 */
export function motivoErrore(e, ospite) {
  const stato = e && e.response ? e.response.status : 0;
  const codice = e && e.response && e.response.data ? e.response.data.code : '';
  let tipo = 'altro';
  if (e && e.senzaCredito) tipo = 'credito';
  else if (e && (e.code === 'ECONNABORTED' || (!e.response && e.request))) tipo = 'nonRisponde';
  else if (codice === 'PROVA_NON_DISPONIBILE') tipo = 'prova';
  /* I codici di casino-service (AvvioService, CatalogoService): ognuno ha la
     sua frase, non quella dello stato HTTP che gli capita di avere. */
  else if (codice === 'VALUTA_SCONOSCIUTA') tipo = 'credito';
  else if (codice === 'LIVELLO_NON_GIOCA') tipo = 'livello';
  /* Bloccato dal backoffice per lui o per la sua rete (scheda utente ›
     Comandi rapidi › Gioco): non e' la sessione scaduta, e rientrare non
     servirebbe. */
  else if (codice === 'GIOCO_NON_ABILITATO') tipo = 'nonAbilitato';
  else if (codice === 'VALUTA_NON_SUPPORTATA') tipo = 'valuta';
  else if (codice === 'GIOCO_SPENTO' || codice === 'GIOCO_NON_ATTIVO' || codice === 'GIOCO_NON_TROVATO') tipo = 'nonDisponibile';
  else if (stato === 401 || stato === 403) tipo = ospite ? 'accesso' : 'sessione';
  else if (stato === 404) tipo = 'nonDisponibile';
  else if (stato >= 500) tipo = 'nonRisponde';
  return {tipo, codice: stato || '', tecnico: e && e.senzaCredito ? i18next.t('Saldo disponibile a zero: avvio non chiesto') : dettaglioTecnico(e)};
}

/** Codice e dettaglio del servizio, per chi compone la skin. */
function dettaglioTecnico(e) {
  const t = (chiave, valori) => i18n.t(chiave, valori);
  if (!e) return t('Errore sconosciuto');
  if (e.code === 'ECONNABORTED') return t('Nessuna risposta dal casinò (tempo scaduto)');
  if (e.response) {
    const corpo = e.response.data || {};
    const dettaglio = corpo.message || corpo.error || e.response.statusText || '';
    const codice = corpo.code ? e.response.status + ' ' + corpo.code : e.response.status;
    return dettaglio
      ? t('Errore {{codice}} - {{dettaglio}}', {codice, dettaglio})
      : t('Errore {{codice}}', {codice});
  }
  if (e.request) return t('Casinò non raggiungibile (nessuna risposta dalla rete)');
  return String(e.message || e);
}

/* I PREFERITI stanno nel browser, non sul conto: la lobby e' pubblica. */
const CHIAVE_PREFERITI = 'lvc.casino.preferiti';

export function preferiti() {
  try {
    const v = JSON.parse(window.localStorage.getItem(CHIAVE_PREFERITI) || '[]');
    return Array.isArray(v) ? v.map(String) : [];
  } catch (e) {
    return [];
  }
}

export function cambiaPreferito(id) {
  const ora = preferiti();
  const dopo = ora.includes(id) ? ora.filter((x) => x !== id) : ora.concat(id);
  try {
    window.localStorage.setItem(CHIAVE_PREFERITI, JSON.stringify(dopo));
  } catch (e) { /* senza memoria nel browser i preferiti valgono per la pagina */ }
  return dopo;
}

/*
 * I GIOCATI DI RECENTE stanno sul conto, non nel browser: casino-service li
 * prende dalle sessioni di gioco (una per ogni gioco aperto col conto, mai in
 * prova), il piu' recente per primo, ognuno una volta sola, al massimo 20.
 * Cosi' chi esce non li vede piu', e chi rientra (anche da un altro
 * dispositivo) ritrova gli stessi. Ognuno ricorda la sezione, perche' la Home
 * deve sapere quale elenco del fornitore chiedere.
 *
 *   GET /private/casino/giochi/recenti -> [{id, sezione}]
 *
 * Da scollegati non si chiede niente: la risposta e' un elenco vuoto.
 */
export function recenti() {
  if (!window.localStorage.getItem('access_token')) return Promise.resolve([]);
  return axios
      .get(`${base()}/private/casino/giochi/recenti`, {headers: intestazioni(), timeout: 8000})
      .then((res) => (Array.isArray(res.data) ? res.data : [])
          .filter((x) => x && x.id && (x.sezione === 'casino' || x.sezione === 'liveCasino'))
          .map((x) => ({id: String(x.id), sezione: x.sezione})));
}

/*
 * IL SALDO BONUS sta su casino-service, non sul conto: sono i bonus dati dalle
 * campagne (benvenuto, deposito, classifica) che il giocatore non puo'
 * prelevare finche' non ha giocato quanto chiede la campagna. Il saldo vero
 * resta quello del credit-service; questo gli si mostra accanto.
 *
 *   GET /private/casino/bonus/saldo?valuta=EUR
 *        -> {valuta, saldoBonus: "12.50", prelevabile: "0.00",
 *            bonus: [{tipo, importo, requisito, giocato, stato, ...}]}
 *
 * Da scollegati non si chiede niente. Se casino-service non risponde (o non
 * ha ancora la rotta) il saldo bonus non c'e': null, e il sito va avanti.
 */
export function saldoBonus(valuta) {
  if (!window.localStorage.getItem('access_token')) return Promise.resolve(null);
  return axios
      .get(`${base()}/private/casino/bonus/saldo`, {
        params: valuta ? {valuta} : {},
        headers: intestazioni(),
        timeout: 8000,
      })
      .then((res) => {
        const d = res.data || {};
        const saldo = Number(d.saldoBonus);
        if (Number.isNaN(saldo)) return null;
        const attivi = (Array.isArray(d.bonus) ? d.bonus : [])
            .filter((b) => b && b.stato === 'ATTIVO')
            .map((b) => ({
              tipo: b.tipo || '',
              importo: Number(b.importo) || 0,
              requisito: Number(b.requisito) || 0,
              giocato: Number(b.giocato) || 0,
            }));
        return {saldo, attivi};
      })
      .catch((e) => {
        console.warn('Saldo bonus non disponibile:', e && e.message);
        return null;
      });
}

/*
 * LE VINCITE VERE DEL SITO (casino-service, VinciteService): la Hall of Fame
 * (modo «grandi») e «Vincendo ora» della Home (modo «recenti»).
 *
 *   GET /public/casino/vincite?modo=grandi|recenti&periodo=settimana|mese|anno|sempre
 *       &quante=10&minimo=0&moltiplicatore=0&sezione=casino|liveCasino|crashGame|...
 *        -> {modo, periodo, valuta, sezione, sezioni, vincite: [{id, quando, giocatore, giocoId, gioco,
 *            copertina, sezione, importo, valuta, moltiplicatore}]}
 *
 * Pubblica: solo i giocatori di questo sito, il nome gia' accorciato dal
 * servizio («Ma***o»). Le grandi stanno in una valuta (quella di chi guarda
 * se e' entrato: il gettone va col resto). Se non risponde, la promessa
 * fallisce e chi la usa torna allo scheletro: mai vincite inventate.
 */
function vincita(v) {
  return {
    id: String(v.id),
    quando: v.quando || '',
    giocatore: v.giocatore || '***',
    giocoId: v.giocoId ? String(v.giocoId) : '',
    gioco: v.gioco || '',
    copertina: v.copertina || '',
    sezione: v.sezione || 'casino',
    importo: Number(v.importo) || 0,
    valuta: v.valuta || '',
    moltiplicatore: v.moltiplicatore === null || v.moltiplicatore === undefined ? null : Number(v.moltiplicatore),
  };
}

/*
 * I RECORD DI SEMPRE per sezione (casino-service, VinciteService.record):
 *
 *   GET /public/casino/vincite/record?sezione=casino,liveCasino
 *        -> {valuta, record: [{sezione, grande: vincita|null, moltiplicatore: vincita|null}]}
 */
export function record(parametri) {
  const params = {};
  Object.entries(parametri || {}).forEach(([k, v]) => {
    if (v !== undefined && v !== null && v !== '') params[k] = v;
  });
  return axios
      .get(`${base()}/public/casino/vincite/record`, {params, headers: intestazioni(), timeout: 10000})
      .then((res) => {
        const d = res.data && typeof res.data === 'object' ? res.data : {};
        return {
          valuta: d.valuta || '',
          record: (Array.isArray(d.record) ? d.record : []).filter((r) => r && r.sezione).map((r) => ({
            sezione: String(r.sezione),
            grande: r.grande ? vincita(r.grande) : null,
            moltiplicatore: r.moltiplicatore ? vincita(r.moltiplicatore) : null,
          })),
        };
      });
}

export function vincite(parametri) {
  const params = {};
  Object.entries(parametri || {}).forEach(([k, v]) => {
    if (v !== undefined && v !== null && v !== '' && !(typeof v === 'number' && !Number.isFinite(v))) params[k] = v;
  });
  return axios
      .get(`${base()}/public/casino/vincite`, {params, headers: intestazioni(), timeout: 10000})
      .then((res) => {
        const d = res.data && typeof res.data === 'object' ? res.data : {};
        return {
          modo: d.modo || params.modo || 'grandi',
          periodo: d.periodo || params.periodo || '',
          valuta: d.valuta || '',
          sezione: d.sezione || '',
          sezioni: Array.isArray(d.sezioni) ? d.sezioni.map(String) : [],
          vincite: Array.isArray(d.vincite) ? d.vincite.map(vincita) : [],
        };
      });
}

/*
 * IL PROGRAMMA FEDELTA' (casino-service, FedeltaService): il programma della
 * skin (o del nodo piu' vicino sopra il giocatore), coi livelli e i premi, e
 * per chi e' entrato i suoi punti.
 *
 *   GET /private/casino/fedelta (col gettone)
 *        -> {escluso, programma, punti, scadono, livello: {indice, nome, soglia, mancano},
 *            prossimo: livello|null, settimana: {chiave, valute: [{valuta, giocato, rakeback}]}}
 *   GET /public/casino/fedelta (ospite: la skin del dominio)
 *        -> {programma}
 *   programma = {nome, inCorso, validoDal, validoAl, scadenzaGiorni,
 *                tassi: {EUR: "10"}, pesi: {liveCasino: 20}, livelli: [{nome, soglia, premioSalita: {EUR: "10"}, rakeback: "0.05"}]}
 *
 * Lo chiedono in tre (testata, colonna del conto, pagina /fedelta): una
 * richiesta sola, tenuta 30 secondi; `fresco` la rifa' (dopo una puntata i
 * punti cambiano). Senza programma: programma null. Se il servizio non
 * risponde la promessa fallisce: niente punti inventati.
 */
const FEDELTA_TIENI = 30 * 1000;
let fedeltaLetta = null; /* {chi, quando, promessa} */

function programmaFedelta(p) {
  if (!p || typeof p !== 'object') return null;
  const livelli = (Array.isArray(p.livelli) ? p.livelli : [])
      .filter((l) => l && l.nome)
      .map((l) => ({
        nome: String(l.nome),
        soglia: Number(l.soglia) || 0,
        premioSalita: l.premioSalita && typeof l.premioSalita === 'object' ? l.premioSalita : {},
        rakeback: Number(l.rakeback) || 0,
      }));
  if (!livelli.length) return null;
  return {
    nome: p.nome || '',
    inCorso: !!p.inCorso,
    validoDal: p.validoDal || null,
    validoAl: p.validoAl || null,
    scadenzaGiorni: Number(p.scadenzaGiorni) > 0 ? Number(p.scadenzaGiorni) : null,
    tassi: p.tassi && typeof p.tassi === 'object' ? p.tassi : {},
    pesi: p.pesi && typeof p.pesi === 'object' ? p.pesi : {},
    livelli,
  };
}

function livelloFedelta(l) {
  if (!l || typeof l !== 'object' || !l.nome) return null;
  return {indice: Number(l.indice) || 0, nome: String(l.nome), soglia: Number(l.soglia) || 0, mancano: Number(l.mancano) || 0};
}

export function fedelta(fresco) {
  const token = window.localStorage.getItem('access_token');
  const chi = token || 'ospite';
  const ora = Date.now();
  if (!fresco && fedeltaLetta && fedeltaLetta.chi === chi && ora - fedeltaLetta.quando < FEDELTA_TIENI) return fedeltaLetta.promessa;
  const promessa = axios
      .get(`${base()}${token ? '/private' : '/public'}/casino/fedelta`, {headers: intestazioni(), timeout: 8000})
      .then((res) => {
        const d = res.data && typeof res.data === 'object' ? res.data : {};
        const programma = programmaFedelta(d.programma);
        if (!token || !programma) return {ospite: !token, escluso: !!d.escluso, programma};
        const settimana = d.settimana && Array.isArray(d.settimana.valute) ? d.settimana.valute : [];
        return {
          ospite: false,
          escluso: !!d.escluso,
          programma,
          punti: Number(d.punti) || 0,
          scadono: d.scadono || null,
          livello: livelloFedelta(d.livello),
          prossimo: livelloFedelta(d.prossimo),
          settimana: settimana.filter((v) => v && v.valuta).map((v) => ({
            valuta: String(v.valuta), giocato: Number(v.giocato) || 0, rakeback: Number(v.rakeback) || 0,
          })),
        };
      });
  fedeltaLetta = {chi, quando: ora, promessa};
  promessa.catch(() => { if (fedeltaLetta && fedeltaLetta.promessa === promessa) fedeltaLetta = null; });
  return promessa;
}
